import { Colors } from '../../theme'

export default {
  display: 'inline-block',
  borderRadius: 0,
  fontSize: '0.83rem',
  minHeight: 42,
  minWidth: 146,
  opacity: 1.0,
  color: 'rgba(0, 0, 0, 0.87)', // update this to config colours,
  '& > span': {
    display: 'flex',
    alignItems: 'center'
  },
  '&.flex': {
    display: 'inline-flex'
  },
  '&.fullWidth': {
    width: '100%'
  },
  '&.disabled': {
    opacity: 0.5,
    cursor: 'not-allowed'
  },
  '&.primary': {
    color: Colors.Palette.whiteColor
  },
  '&.color': {
    color: Colors.Palette.primaryColor
  },
  '&.outlined': {
    boxShadow: `0px 1px 5px 0px ${Colors.Palette.shadowColor}, 0px 2px 2px 0px ${Colors.Palette.shadowColor}, 0px 3px 1px -2px ${Colors.Palette.shadowColor}`
  }
}



// WEBPACK FOOTER //
// ./src/styles/buttons/base.js